export default __webpack_public_path__ + "static/media/hotNewsBanner.3ebd339b.png";